import { composeWithDevTools } from "redux-devtools-extension";
import { createMigrate, persistStore, persistReducer } from "redux-persist"; // allows your app to persist by saving to local storage
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { configureStore } from "@reduxjs/toolkit";
import { getPersistConfig } from "redux-deep-persist";

import thunk from "redux-thunk";
// import root from "./reducers/root";
import newRoot from "./store/root";
// import { createStore, applyMiddleware } from 'redux';
// import hardSet from 'redux-persist/es/stateReconciler/hardSet';

import migrations from "./store/migrations";

// Bump `version` together with a matching key in ./store/migrations.js.
// v1 (#168): single-account user slice → multi-account shape.
export const PERSIST_VERSION = 1;

const persistConfig = getPersistConfig({
	key: "root",
	storage,
	stateReconciler: autoMergeLevel2,
	blacklist: ["user.errors", "user.success", "user.pending", "user.newRes", "user.recentCheckout"],
	rootReducer: newRoot,
	version: PERSIST_VERSION,
	migrate: createMigrate(migrations, { debug: true }),
});

const persistedReducer = persistReducer(persistConfig, newRoot);

export const store = configureStore({
	reducer: persistedReducer,
	devTools: process.env.NODE_ENV !== "production",
	middleware: [thunk],
});

// export const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)));

export const persistor = persistStore(store);
